export const EditorDisabled = () => {
    return (
        <div className="editor-disabled">
            <div className="text-center max-width-550">
                <strong>⚠️ Custom HTML enabled</strong>
                <p>If you want to use the visual editor, you need to delete the custom HTML content and save your changes.</p>
            </div>
        </div>
    )
}